<template>
  <div class='sex-container'>
      <div class='sex-main'>
        <div class='sex-head'>
          <van-nav-bar
              title="性别"
              left-text="取消"
              :border="false"
              @click-left="onCancal"
            >
             <template #right>
                <div class='btn-save' @click='onClickSave'>
                  保存
                </div>
              </template>
          </van-nav-bar>
        </div>
        <div class='sex-title'>选择性别</div>
        <div class='sex-checkCard'>
          <div class='sex-cardInfo'>
            <div @click="handleCheckSex('man')" class='handleCheck'>
              <span class='txt2'>男</span>
              <div :class="{'sex-checked': checkout === 'man'}">
                <img src="../assets/btn_tick.png" alt="">
              </div>
            </div>
            <div class="hr"></div>
            <div @click="handleCheckSex('woman')" class='handleCheck'>
              <span class='txt3'>女</span>
              <div :class="{'sex-checked': checkout === 'woman'}">
                <img src="../assets/btn_tick.png" alt="">
              </div>
            </div>
          </div>
        </div>
      </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      checkout: 'woman'
    };
  },
  methods: {
    onClickSave(e) {
      alert(1);
      // 保存，请求
    },
    onCancal() {
       this.$router.go(-1);
    },
    handleCheckSex (sex) {
      this.checkout = sex;
    }
  }
};
</script>
<style lang='less' src='../style/checkSex.less' />



// WEBPACK FOOTER //
// src/views/checkSex.vue